import { NavLink, Outlet } from "react-router-dom";
import repairIcon from "@img/repair.svg";



const courseList = [
  { id: "trial", name: "Бесплатный урок", isActive: true },
  { id: "amazon", name: "Амазон", isActive: true },
  { id: "amazonInvest", name: "Амазон без вложений", isActive: true },
  
];

export default function CoursePage() {
  return (
    <div className="coursePage">
      <div className="wrapper">
        <div className="coursePage-navigation">
          {courseList.map(({ id, name, isActive }) =>
            isActive ? (
              <NavLink
                key={id}
                to={`/course/${id}/lessons`}
                className={({ isActive: isNavActive }) =>
                  [
                    "coursePage-navigation__item",
                    isNavActive ? "coursePage-navigation__item--active" : "",
                  ].join(" ")
                }
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  {name}
                </div>
              </NavLink>
            ) : (
              <div
                key={id}
                className="coursePage-navigation__item coursePage-navigation__item--disabled"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  cursor: "not-allowed",
                  opacity: 0.6,
                }}
              >
                {name}
                <img
                  width={20}
                  className="onProgress"
                  src={repairIcon}
                  alt="repair-icon"
                />
              </div>
            ),
          )}
        </div>
        <Outlet />
      </div>
    </div>
  );
}
